<template lang="pug">
.card.market-card
  .card-header.bg-more-head.collapse-more(
    :id="'heading-oxtou-' + id"
    data-toggle='collapse'
    :data-target="'#collapse-oxtou-' + id"
    :aria-controls="'collapse-oxtou-' + id"
    aria-expanded=true
  )
    .flex-grow-1.text-ellipsis.text-uppercase.mr-2 {{ $t("m.BT_1X2OU") }}
  .collapse.show(
    :aria-labelledby="'heading-oxtou-' + id"
    :id="'collapse-oxtou-' + id"
  )
    .card-body.p-0
      .market-card-content
        .normal(v-if="mode == 0 || mode == 1")
          .normal-title {{ $t("ui.full_time") }}
          .normal-odd-area
            .normal-odd-area-group(v-for="item in col")
              .normal-odd-area-oddtype.text-center.mr-0(v-if="moreItems['oxtouo'][item] && moreItems['oxtouo'][item][7]") {{ $t("m.BT_" + item) }} ({{ moreItems['oxtouo'][item][7] }})
              .normal-odd-area-oddtype.text-center.mr-0(v-else) {{ $t("m.BT_" + item) }}
              template(v-if="moreItems['oxtouo'][item] && moreItems['oxtouo'][item][5] != 0 && moreItems['oxtouo'][item][5] != ''")
                OddsItem(:odds="moreItems['oxtouo'][item]" idx=5 :typ="oddsType" dataType="3" :details="moreItems" mode="oxtouo")
              template(v-else)
                OddsDisabled
</template>

<script>
import OddsItem from "@/components/mobile/main/xitem/oddsItem";
import OddsDisabled from "@/components/mobile/main/xitem/oddsDisabled";
import mixinHDPOUOdds from "@/library/mixinHDPOUOdds";

export default {
  components: {
    OddsItem,
    OddsDisabled
  },
  mixins: [mixinHDPOUOdds],
  props: {
    mode: {
      type: Number
    }
  },
  data() {
    return {
      col: ["1O", "1U", "XO", "XU", "2O", "2U"],
    }
  }
}
</script>